import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {TestExecution} from '../../../data/models/execution/test-execution';
import {Test} from '../../../data/models/test/test';
import {MeService} from '../../../services/api/me.service';
import {TestExecutionService} from '../../../services/api/execution/test-execution.service';
import {MatDialog} from '@angular/material/dialog';
import {TestExecutionFinishDialogComponent} from '../../dialogs/test-execution-finish-dialog/test-execution-finish-dialog.component';

@Component({
  selector: 'app-test-execution',
  templateUrl: './test-execution.component.html',
  styleUrls: ['./test-execution.component.css']
})
export class TestExecutionComponent implements OnInit, OnDestroy {

  @Input() urlCode?: string;
  @Input() testId?: number;

  test: Test | null = null;
  unfinishedExecution: TestExecution | null = null;
  finishedExecution: TestExecution | null = null;

  currentExecution: TestExecution | null = null;

  expiryCheckInterval: number | null = null;
  expiryDate: Date | null = null;
  expired = false;
  showErrorMessage = false;

  constructor(
    private dialog: MatDialog,
    private meService: MeService,
    private testExecutionService: TestExecutionService,
  ) {
  }

  ngOnInit(): void {
    let testExecutionsPromise = null;
    if (this.urlCode) {
      testExecutionsPromise = this.testExecutionService.getTestExecutions({urlCode: this.urlCode});
    } else if (this.meService.me && this.testId) {
      testExecutionsPromise = this.testExecutionService.getTestExecutions({testId: this.testId});
    }
    if (testExecutionsPromise) {
      testExecutionsPromise.then(testExecutions => {
        this.test = testExecutions.test;
        this.setUnfinishedExecution(testExecutions.current);
        this.finishedExecution = testExecutions.finished;
      }).catch(() => {
          this.showErrorMessage = true;
      });
    }
  }

  ngOnDestroy(): void {
    if (this.expiryCheckInterval !== null) {
      clearInterval(this.expiryCheckInterval);
    }
  }

  onExecutionStart(execution: TestExecution): void {
    this.setUnfinishedExecution(execution);
    this.currentExecution = execution;
  }

  onExecutionFinish(execution: TestExecution): void {
    this.openExecutionFinishDialog(execution);
  }

  openExecutionFinishDialog(execution: TestExecution): void {
    const dialogRef = this.dialog.open(TestExecutionFinishDialogComponent, {
      data: {
        execution: execution, testType: (this.test !== null ? this.test.type : null),
      }
    });

    dialogRef.afterClosed().subscribe(e => {
      if (e) {
        this.setUnfinishedExecution(null);
        this.finishedExecution = e;
        this.currentExecution = e;
      }
    });
  }

  setUnfinishedExecution(execution: TestExecution | null): void {
    this.unfinishedExecution = execution;
    if (execution) {
      if (execution.expiryDate) {
        this.expiryDate = new Date(execution.expiryDate);
        if (this.expiryCheckInterval != null) {
          clearInterval(this.expiryCheckInterval);
        }
        this.expiryCheckInterval = setInterval(() => {
          if (this.expiryDate && new Date().getTime() >= this.expiryDate.getTime()) {
            this.expired = true;
            this.finishedExecution = this.unfinishedExecution;
            this.unfinishedExecution = null;
            if (this.expiryCheckInterval != null) {
              clearInterval(this.expiryCheckInterval);
            }
          }
        }, 1000);
      }
    } else {
      if (this.expiryCheckInterval != null) {
        clearInterval(this.expiryCheckInterval);
      }
    }
  }

}
